import { Injectable, Inject } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { ServerResponse } from '../models/types';

@Injectable()
export class ScannerQRService {
  url: any;
  constructor(
    private http: HttpClient,
    @Inject('BASE_URL') baseUrl: string,
  ) {
    this.url = baseUrl;
  }

  //async callAPI_ScanCode(qr: string, mach: string, amount: string,
  //  maHTTT: string, maQuay: string,
  //  MaNV: string, STTHD: number,
  //  hdID: string) {
  //  return await this.http.post(`${this.url}api/ScannerQR/scannerQR`, {
  //    QR_ID: qr,
  //    maCH: mach,
  //    amount: amount,
  //    maHTTT: maHTTT,
  //    maQuay: maQuay,
  //    MaNV: MaNV,
  //    STTHD: STTHD,
  //    hdID: hdID
  //  }).toPromise()
  //    .then((result: ServerResponse) => {
  //      console.log(result.data);
  //      if (result.code === 1) {
  //        return result.data;
  //      }
  //      else
  //      {
  //        if (result.data != null) {
  //          return result.data;
  //        }
  //        else {
  //          throw new Error(result.message);
  //        }
  //      }
  //    });
  //}

  async callQueryMomoAPI(mach: string,
    maHTTT: string, maQuay: string,
    MaNV: string, STTHD: number,
    hdID: string) {
    return await this.http.post(`${this.url}api/ScannerQR/QueryMomo`, {
      maCH: mach,
      maHTTT: maHTTT, maQuay: maQuay,
      MaNV: MaNV, STTHD: STTHD,
      hdID: hdID
    }).toPromise()
      .then((result: ServerResponse) => {
        console.log(result);
        console.log(result.data);
        if (result.code === 1) {
          return result.data;
        }
        else {
          if (result.data != null) {
            return result.data;
          }
          else {
            throw new Error(result.message);
          }
        }
      });
  }


  async callAPI_ScanCode(qr: string, mach: string, amount: string,
    maHTTT: string, maQuay: string,
    MaNV: string, STTHD: number,
    hdID: string) {
    return await this.http.post(`${this.url}api/ScannerQR/callAPI_ScanCode`, {
      QR_ID: qr,
      maCH: mach,
      amount: amount,
      maHTTT: maHTTT,
      maQuay: maQuay,
      MaNV: MaNV,
      STTHD: STTHD,
      hdID: hdID
    }).toPromise()
      .then((result: ServerResponse) => {
        console.log(result.data);
        if (result.code === 1) {
          return result.data;
        }
        else {
          if (result.data != null) {
            return result.data;
          }
          else {
            throw new Error(result.message);
          }
        }
      });
  }

  async callAPI_CreatQR(qr: string, mach: string, amount: string,
    maHTTT: string, maQuay: string,
    MaNV: string, STTHD: number,
    hdID: string) {
    return await this.http.post(`${this.url}api/ScannerQR/callAPI_CreateQR`, {
      QR_ID: qr,
      maCH: mach,
      amount: amount,
      maHTTT: maHTTT,
      maQuay: maQuay,
      MaNV: MaNV,
      STTHD: STTHD,
      hdID: hdID
    }).toPromise()
      .then((result: ServerResponse) => {
        console.log(result.data);
        if (result.code === 1) {
          return result.data;
        }
        else {
          if (result.data != null) {
            return result.data;
          }
          else {
            throw new Error(result.message);
          }
        }
      });
  }

  async callAPI_Query(mach: string,
    maHTTT: string, maQuay: string,
    MaNV: string, STTHD: number,
    hdID: string, amount: string, amount_all?: string, f2?: string) {
    return await this.http.post(`${this.url}api/ScannerQR/callAPI_Query`, {
     
      maCH: mach,
      amount: amount,
      maHTTT: maHTTT,
      maQuay: maQuay,
      MaNV: MaNV,
      STTHD: STTHD,
      hdID: hdID,
      amount_all: amount_all,
      f2: f2
    }).toPromise()
      .then((result: ServerResponse) => {
        console.log(result.data);
        if (result.code === 1) {
          return result.data;
        }
        else {
          if (result.data != null) {
            return result.data;
          }
          else {
            throw new Error(result.message);
          }
        }
      });
  }
  // Gọi API PaymentTransaction để lấy giá trị đúng của BillID
  async callPaymentTransaction_GetValueBillID(MaHD: string, amount: string, storeid: string) {
    return await this.http.post(`${this.url}api/ScannerQR/get_PaymentTransaction`, {
      BillID: MaHD,
      StoreID: storeid,
      Amount: amount
    }).toPromise()
      .then((result: ServerResponse) => {
        console.log(result.data);
        if (result.code === 1) {
          return result.data;
        }
        else {
          if (result.data != null) {
            return result.data;
          }
          else {
            throw new Error(result.message);
          }
        }
      });
  }

  async callQueryVNPAPI(mach: string,
    maHTTT: string, maQuay: string,
    MaNV: string, STTHD: number,
    hdID: string, amount: string) {
    return await this.http.post(`${this.url}api/ScannerQR/QueryVNP`, {
      maCH: mach,
      maHTTT: maHTTT, maQuay: maQuay,
      MaNV: MaNV, STTHD: STTHD, amount: amount,
      hdID: hdID
    }).toPromise()
      .then((result: ServerResponse) => {
        console.log(result);
        console.log(result.data);
        if (result.code === 1) {
          return result.data;
        }
        else {
          if (result.data != null) {
            return result.data;
          }
          else {
            throw new Error(result.message);
          }
        }
      });
  }


  async UpdateCallQueryMomo(Amount: string, MaHD: string, MaCH: string) {
    await this.http.post(`${this.url}api/ScannerQR/Update_QRMomo`, {
      Amount: Amount,
      MaHD: MaHD,
      MaCH: MaCH
    }).toPromise()
      .then(result => {
        console.log(result);
        return result;
      });
  }


  async callVNPAPI(qr: string, mach: string, amount: string,
    maHTTT: string, maQuay: string,
    MaNV: string, STTHD: number,
    hdID: string) {
    return await this.http.post(`${this.url}api/ScannerQR/VnpayCreateQR`, {
      QR_ID: qr,
      maCH: mach,
      amount: amount,
      maHTTT: maHTTT,
      maQuay: maQuay,
      MaNV: MaNV,
      STTHD: STTHD,
      hdID: hdID
    }).toPromise()
      .then((result: ServerResponse) => {
        console.log(result.data);
        if (result.code === 1) {
          return result.data;
        }
        else {
          if (result.data != null) {
            return result.data;
          }
          else {
            throw new Error(result.message);
          }
        }
      });
  }

}



// WEBPACK FOOTER //
// ./src/app/services/ScannerQR.service.ts